import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { refreshAuthToken } from '../redux/features/usersSlice';

const REFRESH_INTERVAL = 5 * 60 * 1000; // Check every 5 minutes

export function useTokenRefresh() {
  const dispatch = useDispatch();
  const authToken = useSelector((state) => state.users.authToken);

  useEffect(() => {
    if (!authToken) return;

    const checkAndRefresh = async () => {
      const bufferMs = 5 * 60 * 1000; // 5 minutes
      if (authToken.expiresAt && Date.now() >= (authToken.expiresAt - bufferMs)) {
        dispatch(refreshAuthToken());
      }
    };

    // Check immediately
    checkAndRefresh();

    // Set up interval
    const interval = setInterval(checkAndRefresh, REFRESH_INTERVAL);

    return () => clearInterval(interval);
  }, [authToken, dispatch]);
}

export default useTokenRefresh;
